export enum ProductReleaseStatus {
    DevRelease, 
    STPStart, 
    QARelease, 
    ProductionRelease,
    PilotRelease,
    CustomRelease
  }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/interfaces/ProductReleaseStatusEnum.model.ts